// eslint-disable-next-line @typescript-eslint/ban-types
export const preventDefaultAndStopPropagation = (cb?: Function) => (e: any) => {
    e.preventDefault()
    e.stopPropagation()
    if (cb) cb(e)
    return false
}


export const getLatitude = (value:string | number | null | undefined) => {
    if (value === null || value === undefined) return null
    if (typeof value === 'string') {
        value = parseFloat(value)
    }
    if (isNaN(value)) return null
    if (value < -90 || value > 90) return null
    return value
}

export const getLongitude = (value:string | number | null | undefined) => {
    if (value === null || value === undefined) return null
    if (typeof value === 'string') {
        value = parseFloat(value)
    }
    if (isNaN(value)) return null
    if (value < -180 || value > 180) return null
    return value
}
